<template>
  <div style="padding: 10px">
    <h1 style="font-weight: 700">Music</h1>
    <br />
    <p style="color: #444444; font-size: 1.1rem">
      Don't you know? I am a music lover too 😎
    </p>
    <br />
    <h2 style="font-weight: 700">On Repeat</h2>
    <p style="color: #444444; font-size: 1.1rem">
      Curious what I'm currently jamming to? Here's my On Repeat playlist on
      Spotify updated in each 5 days.
    </p>
    <br />
    <iframe
      src="https://open.spotify.com/embed/playlist/37i9dQZF1EpzqHyeBMsNeM?utm_source=generator&theme=0"
      width="100%"
      height="380"
      frameBorder="0"
      allowfullscreen=""
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "Music",
};
</script>
